import ICommand from '../../../FrontApplet/Command/ICommand';
import { ITypedCommandEvent } from '../../../FrontApplet/Command/ICommandEvent';
import FrontApplet from '../../../FrontApplet/FrontApplet';
import {
	ManagementAutoRecoveryGetRequest,
	ManagementAutoRecoveryGetResult,
	ManagementAutoRecoveryRequests,
	ManagementAutoRecoverySetRequest,
	ManagementAutoRecoverySetResult,
} from './autoRecoveryCommands';

export function handleManagementAutoRecoveryRequests(
	onCommand: (callback: (commandEvent: ITypedCommandEvent<ManagementAutoRecoveryRequests>) => Promise<void>) => void,
	dispatch: <TCommand extends ICommand>(command: TCommand) => Promise<void>,
	frontApplet: FrontApplet,
) {
	onCommand(async (commandEvent: ITypedCommandEvent<ManagementAutoRecoveryRequests>) => {
		switch (commandEvent.command.type) {
			case ManagementAutoRecoveryGetRequest:
				await dispatch<ManagementAutoRecoveryGetResult>({
					type: ManagementAutoRecoveryGetResult,
					result: await frontApplet.management.autoRecovery.get(),
				});
				break;
			case ManagementAutoRecoverySetRequest:
				await frontApplet.management.autoRecovery.set(commandEvent.command.configuration);
				await dispatch<ManagementAutoRecoverySetResult>({
					type: ManagementAutoRecoverySetResult,
					result: {},
				});
				break;
			default:
		}
	});
}
